import { useState, useMemo } from 'react'
import { useSwipeable } from 'react-swipeable'
import { Grid, Stack, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { LanguageCode, SONG_TYPES, Song } from '../../../utils/types'
import { useCurrentUser } from '../../../hooks/contexts/currentUserContext'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import GridViewIcon from '@mui/icons-material/GridView'
import { useChangeCurrentSong, useCurrentSong } from '../../../hooks/contexts/currentSongContext'
import DisplayedCards from './DisplayedCards'

interface ChooseSongProps {
    type: SONG_TYPES
    searchValue?: string
    category?: string
}

const ChooseSong = ({ type, category, searchValue }: ChooseSongProps) => {
    const currentUser = useCurrentUser()
    const currentSong = useCurrentSong()
    const changeCurrentSong = useChangeCurrentSong()

    const songList = currentUser?.songList || []
    const lang: LanguageCode = currentUser?.customer?.userSettings?.language ?? 'sv'

    const [viewMode, setViewMode] = useState<'grid' | 'list'>('list')

    const filteredSongs = useMemo(() => {
        return songList.filter((song) => song.type === type).filter((song) => (song.type === SONG_TYPES.KEY ? song.keytone === category || category === 'all' : song.translatedCategory === category || category === 'all'))
    }, [songList, type, category])

    const displayedSongs = useMemo(() => {
        if (!searchValue) return filteredSongs

        const search = searchValue.trim().toLowerCase()

        return filteredSongs.filter((song) => song.title.toLowerCase().includes(search))
    }, [filteredSongs, searchValue])

    return (
        <Stack sx={{ height: '100%' }}>
            {type !== SONG_TYPES.KEY && (
                <ToggleButtonGroup value={viewMode} exclusive onChange={(e, v) => v && setViewMode(v)} sx={{ mb: 2 }}>
                    <ToggleButton value="grid">
                        <GridViewIcon />
                    </ToggleButton>
                    <ToggleButton value="list">
                        <FormatListBulletedIcon />
                    </ToggleButton>
                </ToggleButtonGroup>
            )}

            <Grid item xs sx={{ overflow: 'auto', p: 1 }}>
                <DisplayedCards lang={lang} displayedSongs={displayedSongs} viewMode={viewMode} changeCurrentSong={changeCurrentSong} currentSong={currentSong} type={type} />
            </Grid>
        </Stack>
    )
}

export default ChooseSong
